export const PUT_ERROR = 'error/PUT_ERROR';
export const CLEAR_ERRORS = 'error/CLEAR_ERRORS';
export const RESET_GLOBAL_ERROR = 'error/RESET_GLOBAL_ERROR';
export const SET_FOCUS_ON_ERROR = 'error/SET_FOCUS_ON_ERROR';
export const SET_DELAYED_FOCUS_ON_ERROR = 'error/SET_DELAYED_FOCUS_ON_ERROR';

export const SERVER_ERROR = 'SERVER_ERROR';
export const NOT_FOUND_ERROR = 'NOT_FOUND_ERROR';
export const FORBIDDEN_ERROR = 'FORBIDDEN_ERROR';
